import { Dialog } from '@/ui'

interface ClarifyingModalProps {
  open: boolean
  onClose: () => void
  title: string
  content: React.ReactNode
  actions: React.ReactNode
  closeIcon?: boolean
}

export const ClarifyingModal = ({
  open,
  onClose,
  title,
  content,
  actions,
}: ClarifyingModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Dialog.Content className="max-w-sm">
        <Dialog.Title asChild>{title}</Dialog.Title>

        <div>{content}</div>

        <Dialog.Footer>{actions}</Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
